module.exports = __webpack_public_path__ + "img/logo_garuda_indonesia.88982b1d.png";